export const SUCCESS_GET_ALL_CRON_OPTIONS = 'SUCCESS_GET_ALL_CRON_OPTIONS';
export const FAILED_GET_ALL_CRON_OPTIONS = 'FAILED_GET_ALL_CRON_OPTIONS';
export const SUCCESS_UPDATE_CRON_OPTION = 'SUCCESS_UPDATE_CRON_OPTION';
export const FAILED_UPDATE_CRON_OPTION = 'FAILED_UPDATE_CRON_OPTION';




// WEBPACK FOOTER //
// ./src/state/constants/cronOptionConstants.js